import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <div className="ml-20 mr-20 blog-title">
      <h2 className="text-center mt-6 text-3xl font-bold text-amber-600 ">
        Question and Answer
      </h2>
      <div className="border border-black mt-2"></div>
      <div className="mt-6 blog-questions">
        <h2 className="text-xl font-bold">
          1. What is the purposes of React Router?
        </h2>
        <p className="ml-6 mt-2 font-bold">
          React Router is a standard library for routing in React. It enables
          the navigation among views of various components in a React
          Application, allows changing the browser URL, and keeps the UI in sync
          with the URL.
        </p>
        <h2 className="text-xl font-bold mt-6">
          2. How does Context API work?
        </h2>
        <p className="ml-6 mt-2 font-bold">
          The React Context API is a way for a React app to effectively produce
          global variables that can be passed around. This is the alternative to
          "prop drilling" or moving props from grandparent to child to parent,
          and so on. Context is also touted as an easier, lighter approach to
          state management using Redux.
        </p>
        <h2 className="text-xl font-bold mt-6">3. What is useRef hook?</h2>
        <p className="ml-6 mt-2 font-bold">
          The useRef Hook allows you to persist values between renders. It can
          be used to store a mutable value that does not cause a re-render when
          updated. It can be used to access a DOM element directly.
        </p>
      </div>
    </div>
  );
};

export default Blog;
